import React, { Component } from 'react';
import ReactCardFlip from 'react-card-flip';
import { withSnackbar } from 'notistack';

import { ScreenTitle } from '../../../components/atoms';
import LoadingModal from '../../../components/atoms/LoadingModal';
import './style.scss';
import MessageModal from '../../../components/molecules/MessageModal/index';
import {
  achievement_1_details,
  achievement_8_details,
  achievement_2_details,
  achievementName_1,
  achievementName_2,
} from '../../../shared/constants/AchievementConstants';
import { ROUTE_CONSTANTS } from '../../../shared/constants/Route';
import { fetchListOfCards } from '../../../shared/services/api/apiFlash';

class DisplayFlashCardsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFlipped: false,
      visibleCardIndex: props.cardViewedIndex,
      currentCardIndex: props.cardViewedIndex,
      totalCards: 0,
      flashcardDetailArray: [],
      visibleFlashCardList: [],
      showAchievementModal: false,
      showPurchaseGameModal: false,
      message: ' ',
      currentHidden: 0,
      loading: props.loading,
      lastCard: false,
      viewedCardList: props.FlashCardReducer.flashCardDetailList,
      updateData: true,

    };
    this.handleClick = this.handleClick.bind(this);
    this.oldHiddenCards = 0;
    this.cardViewed = 0;

    this.cardViewedIndex = props.cardViewedIndex;

    this.achievementName = '';
    this.achievementDetailsText = '';
  }

  handleClick(e) {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
    this.addingFlashCardDetails(
      1,
      0,
      this.state.visibleFlashCardList[this.state.visibleCardIndex].flashcardId,
    );
    this.updateFlashCardDetails();
  }

  componentWillUnmount() {
    this.updateFlashCardDetails();
    this.fetchFlashCardCount();
  }

  fetchFlashCardCount() {
    const userId = {
      userId: this.props.userId,
      sessionToken: this.props.sessionToken,
    };

    // const flashCardDetails = {
    //   userId: this.props.userId,
    //   sessionToken: this.props.sessionToken,
    //   flashCardArray: this.state.flashcardDetailArray
    // };

    // this.props.submitFlashCardDetails(
    //   flashCardDetails,
    //   (message, type) => {
    //     this.props.enqueueSnackbar(message, {
    //       variant: type,
    //       autoHideDuration: 3000,
    //       anchorOrigin: {
    //         vertical: "bottom",
    //         horizontal: "left",
    //       },
    //     });
    //   });
    // this.props.getTotalFlashcards(userId, () => {
    // },
    //   (message, type) => {
    //     this.props.enqueueSnackbar(message, {
    //       variant: type,
    //       autoHideDuration: 3000,
    //       anchorOrigin: {
    //         vertical: "bottom",
    //         horizontal: "left",
    //       },
    //     });
    //   },
    //   false
    // );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps !== prevState) {
      return {
        loading: nextProps.loading,
        firstCardViewed: nextProps.firstCardViewed,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.props !== prevProps) {
      let viewedCount = 0,
        hiddenCount = 0;
      if (this.props.FlashCardReducer) {
        let flashCardArray = this.props.FlashCardReducer.flashCardDetailList;
        flashCardArray.map((flashCard) => {
          /* special case */
          {
            if (flashCard.isViewed === true) {
              flashCard.isViewed = '1';
            }
            if (flashCard.isViewed === false) {
              flashCard.isViewed = '0';
            }
            if (flashCard.isHidden === true) {
              flashCard.isHidden = '1';
            }
            if (flashCard.isHidden === false) {
              flashCard.isHidden = '0';
            }
          }
          /* end special case */

          if (parseInt(flashCard.isViewed) && !parseInt(flashCard.isHidden)) {
            viewedCount++;
          }
          if (parseInt(flashCard.isHidden)) {
            hiddenCount++;
          }
        });
      }
      this.oldHiddenCards = viewedCount + hiddenCount;

      const flashCardDetails = {
        userId: this.props.userId,
        sessionToken: this.props.sessionToken,
        flashCardArray: this.state.viewedCardList,
      };

      this.props.submitFlashCardDetails(flashCardDetails, (message, type) => {
        this.props.enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });

      });

      let cards = this.gettingTotalVisibleCards();

      this.setState(
        {
          visibleFlashCardList: [...cards],
          totalCards: cards.length,
          //loading: false
        },
        () => {
          //this.setState({ loading: false })
        },
      );
    }

  }

  componentDidMount() {

    let flashcardDetails = {
      userId: this.props.userId,
      sessionToken: this.props.sessionToken,
    };

    // this.props.getTotalFlashcards(
    //   flashcardDetails,
    //   () => { },
    //   (message, type) => {
    //     this.props.enqueueSnackbar(message, {
    //       variant: type,
    //       autoHideDuration: 3000,
    //       anchorOrigin: {
    //         vertical: "bottom",
    //         horizontal: "left",
    //       },
    //     });
    //   },
    //   false
    // );

    this.props.getListOfFlashCards(
      flashcardDetails,
      (message, type) => {
        this.props.enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
      true,
    );

    let viewedCount = 0,
      hiddenCount = 0;
    if (this.props.FlashCardReducer) {
      let flashCardArray = this.props.FlashCardReducer.flashCardDetailList;

      let temp = flashCardArray.map((flashCard) => {
        /* special case */
        {
          if (flashCard.isViewed === true) {
            flashCard.isViewed = '1';
          }
          if (flashCard.isViewed === false) {
            flashCard.isViewed = '0';
          }
          if (flashCard.isHidden === true) {
            flashCard.isHidden = '1';
          }
          if (flashCard.isHidden === false) {
            flashCard.isHidden = '0';
          }
        }

        /* end special case */

        if (parseInt(flashCard.isViewed) && !parseInt(flashCard.isHidden)) {
          return viewedCount++;
        }
        if (parseInt(flashCard.isHidden)) {
          return hiddenCount++;
        }
      });
    }
    this.oldHiddenCards = viewedCount + hiddenCount;

    let cards = this.gettingTotalVisibleCards();

    this.setState(
      {
        visibleFlashCardList: [...cards],
        totalCards: cards.length,
      },
      () => {
        //this.addingFlashCardDetails(1, 0, (this.state.visibleFlashCardList[this.state.visibleCardIndex]).flashcardId);
      },
    );

  }

  //Showing only those cards which are not hidden
  gettingTotalVisibleCards() {
    let flashCardhiddenList = this.props.FlashCardReducer.flashCardDetailList.filter(
      (flashCardDetailCard) => {
        return (
          flashCardDetailCard.isHidden == 1 ||
          flashCardDetailCard.isHidden == true
        );
      },
    );
    var flashCardIDS = flashCardhiddenList.map(function (flashcardId) {
      return flashcardId['flashcardId'];
    });

    let visibleFlashCardsList = this.props.FlashCardReducer.listOfCards.filter(
      (flashCard) => {
        return !flashCardIDS.includes(flashCard.flashcardId);
      },
    );

    if (flashCardhiddenList.length === 697) {
      this.props.history.replace(ROUTE_CONSTANTS.ROOT);
    }

    return visibleFlashCardsList;
  }

  hideCard(cardId) {

    this.setState({ loading: true });

    let lastCardIndex = this.state.currentCardIndex;
    this.addingFlashCardDetails(0, 1, cardId);
    this.setState(
      {
        isFlipped: false,
        currentHidden: this.state.currentHidden + 1,
      },
      () => {

        let currentCardIndex = this.state.currentCardIndex + 1;

        let totalPurchase = currentCardIndex + 1 + this.oldHiddenCards;
        if (this.props.purchaseStatus === false) {
          if (totalPurchase >= 26) {
            this.setState({ showPurchaseGameModal: true });
            return;
          }
        }
        // Go to next visible card

        let flashCardArray = this.state.flashcardDetailArray;
        let visibleFlashCardList = this.state.visibleFlashCardList;
        while (true) {
          let index = flashCardArray.findIndex(
            (flashCard) =>
              flashCard.flashcardId ==
              (visibleFlashCardList[currentCardIndex] || {}).flashcardId &&
              flashCard.isHidden,
          );
          if (index === -1) {
            break;
          }
          currentCardIndex += 1;
        }

        if (
          this.state.currentCardIndex ==
          this.state.visibleFlashCardList.length - 1
        ) {
          lastCardIndex = currentCardIndex;

        } else {
          this.state.currentCardIndex = currentCardIndex - 1;

        }

        let scrollTo =
          this.state.currentCardIndex >= this.state.visibleFlashCardList.length
            ? this.state.visibleFlashCardList.length - 1
            : this.state.currentCardIndex;

        let totalHidden = this.state.currentCardIndex + 1 + this.oldHiddenCards;

        //Update cards details
        if (this.props.purchaseStatus !== false || totalHidden <= 25) {

          this.updateFlashCardDetails();
        }

        if (Math.abs(lastCardIndex - scrollTo) >= 1) {

          this.setState({
            visibleCardIndex: scrollTo - 1,
            currentCardIndex: scrollTo - 1,
          });
        } else {

          this.setState({
            visibleCardIndex: scrollTo,
          });
        }

        // const flashCardDetails = {
        //   userId: this.props.userId,
        //   sessionToken: this.props.sessionToken,
        //   flashCardArray: this.state.flashcardDetailArray,
        // };

        // this.props.submitFlashCardDetails(flashCardDetails, (message, type) => {
        //   this.props.enqueueSnackbar(message, {
        //     variant: type,
        //     autoHideDuration: 3000,
        //     anchorOrigin: {
        //       vertical: "bottom",
        //       horizontal: "left",
        //     },
        //   });
        // });

        /* purchase game status */

        // if (this.props.purchaseStatus == false) {
        //   if (totalHidden >= 26) {
        //     this.setState({ showPurchaseGameModal: true });
        //   }
        // }
      },
    );
  }

  //Adding details for flascard wehter it is been viewed or hidden along with it's id
  addingFlashCardDetails(isViewed, isHidden, cardId) {
    let flashCardObject = {};
    let flashCardArray = this.state.flashcardDetailArray;
    let index = flashCardArray.findIndex(
      (flashCard) => flashCard.flashcardId == cardId,
    );
    flashCardObject.flashcardId = cardId;
    flashCardObject.isViewed = isViewed;
    flashCardObject.isHidden = isHidden;
    if (index != -1) {
      flashCardArray[index] = flashCardObject;
    } else {
      flashCardArray.push(flashCardObject);
    }

    this.setState({ flashcardDetailArray: flashCardArray });
  }

  updateFlashCardDetails() {
    let currentViewed = this.cardViewedIndex + this.cardViewed;
    this.props.updateFlashCard(this.state.flashcardDetailArray);
    this.props.flashCardIndex(currentViewed > 0 ? currentViewed : 0);
  }

  slideCard(cardOffset) {

    let lastCardIndex = this.state.currentCardIndex;
    if (this.state.currentCardIndex === 0 && cardOffset === -1) {
      return;
    }
    if (this.state.currentCardIndex < this.state.totalCards) {
      this.setState(
        {
          isFlipped: false,
        },
        () => {
          let currentCardIndex = this.state.currentCardIndex + cardOffset;

          let flashCardArray = this.state.flashcardDetailArray;
          let visibleFlashCardList = this.state.visibleFlashCardList;

          let data = {
            flashcardId: currentCardIndex,
            isViewed: 1,
            isHidden: 0,
          };

          this.setState({ viewedCardList: [...this.state.viewedCardList, data] });

          while (true) {
            let index = flashCardArray.findIndex(
              (flashCard) =>
                flashCard.flashcardId ==
                (visibleFlashCardList[currentCardIndex] || {}).flashcardId &&
                flashCard.isHidden,
            );
            if (index === -1) {
              break;
            }
            currentCardIndex += cardOffset;
          }

          let totalPurchase = currentCardIndex + 1 + this.oldHiddenCards;
          if (this.props.purchaseStatus == false) {
            if (totalPurchase >= 26) {
              this.setState({ showPurchaseGameModal: true });
              return;
            }
          }

          if (currentCardIndex >= 0) {
            this.cardViewed += cardOffset;

            this.setState(
              {
                currentCardIndex,
                // loading:true
              },
              () => {

                let totalHidden = currentCardIndex + 1 + this.oldHiddenCards;

                if (this.props.purchaseStatus !== false || totalHidden <= 25) {
                  this.updateFlashCardDetails();
                }

                let scrollTo =
                  this.state.currentCardIndex >=
                  this.state.visibleFlashCardList.length
                    ? this.state.visibleFlashCardList.length - 1
                    : this.state.currentCardIndex;

                if (Math.abs(lastCardIndex - scrollTo) > 1) {
                  this.setState({
                    visibleCardIndex: scrollTo - cardOffset,
                  });
                }

                this.setState({
                  visibleCardIndex: scrollTo,
                });

                // const flashCardDetails = {
                //   userId: this.props.userId,
                //   sessionToken: this.props.sessionToken,
                //   flashCardArray: this.state.viewedCardList,
                // };

                // this.props.submitFlashCardDetails(
                //   flashCardDetails,
                //   (message, type) => {
                //     this.props.enqueueSnackbar(message, {
                //       variant: type,
                //       autoHideDuration: 3000,
                //       anchorOrigin: {
                //         vertical: "bottom",
                //         horizontal: "left",
                //       },
                //     });
                //   }
                // );

                //    achievement unlocked first card viewed */

                if (!this.props.firstCardViewed) {

                  if (this.state.currentCardIndex == 1) {

                    this.setState({
                      message: achievement_1_details,
                      showAchievementModal: true,
                    });
                    this.achievementDetailsText = achievement_1_details;
                    this.achievementName = achievementName_1;
                    //   this.props.CommonReducer.firstCardViewed = true;
                    //  this.showAchievementModal();
                    //this.props.updateAchievementDetails();
                    this.props.achievement_unlocked('firstCardViewed', true);
                    this.props.state.CommonReducer.unlockedAchievementArray[0] = true;
                  }

                }

                /* purchase game status */

                /* check 50 cards viewed for every 50 cards*/

                if ((currentCardIndex + 1) % 50 === 0) {
                  this.setState({
                    message: achievement_8_details,
                    showAchievementModal: true,
                  });
                }
                //   alert(this.state.totalCards +"FlashCardReducer  "+  currentCardIndex + "as "+visibleFlashCardList.length)

                /* when all cards are viewed */

                if (currentCardIndex === visibleFlashCardList.length - 1) {
                  if (!this.state.lastCard) {
                    this.setState({
                      // lastCard: true,
                      message: achievement_2_details,
                      showAchievementModal: true,
                      lastCard: true,
                    });
                  }

                  // alert("hii");
                  this.achievementDetailsText = achievement_2_details;
                  this.achievementName = achievementName_2;
                  this.props.state.CommonReducer.all_cards_count = 0;
                  // this.showAchievementModal();

                  this.props.state.CommonReducer.unlockedAchievementArray[1] = true;
                }
              },
            );
          }
        },
      );
    }
  }

  renderFlashCard = (flashCardDesc, flashCardTitle, flashCardId) => {
    return (
      <ReactCardFlip
        isFlipped={this.state.isFlipped}
        flipDirection='horizontal'
        key={flashCardId}
      >
        <>
          <div className='flash_block'>
            <div className='outer-div'>
              <div className='image-container'>
                <img
                  src={require('../../../Assets/Images/Icons/flashcard.svg')}
                  alt=''
                  width='60'
                />
                <p>
                  {this.state.currentCardIndex + 1}/
                  {this.state.visibleFlashCardList.length}
                </p>
              </div>
              <div className='card-container'>
                <h4>{'Flash Card'}</h4>
              </div>
            </div>

            <h3>{flashCardTitle}</h3>

            {/* <p style={{ color: "#888", fontWeight: 400 }}>
                    {flashCardDesc}
                  </p> */}

            {/* <button
              onClick={this.handleClick}
              className="btn btn-md btn-primary"
            >
              View Answer
            </button> */}
          </div>
        </>

        <>
          <div
            style={{
              height: 375,
              width: '100%',
              border: '2px solid #cacaca',
              padding: '12px 24px 24px 24px',
              borderRadius: 10,
              boxShadow: '0px 0px 36.4px 3.6px rgba(0, 0, 0, 0.09)',
            }}
          >
            <div className='outer-div'>
              <div className='image-container'>
                <img
                  src={require('../../../Assets/Images/Icons/flashcards.png')}
                  alt=''
                />

                <p>
                  {this.state.currentCardIndex + 1}/
                  {this.state.visibleFlashCardList.length}
                </p>
              </div>
              <div className='card-container'>
                <h4>{'Flash Card'}</h4>
              </div>
            </div>
            <div className='answser_card'>
              <p>{flashCardDesc}</p>
            </div>
            {/* <button
              onClick={this.handleClick}
              className="btn btn-md btn-secondary"
            >
              <i>
                <img
                  src={require("../../../Assets/Images/Icons/back_icon.svg")}
                  alt=""
                />
              </i>{" "}
              Back to Question
            </button> */}
          </div>
        </>
      </ReactCardFlip>
    );
  };

  hideAchievementModal = () => {
    this.setState({ message: '', showAchievementModal: false });
    if (this.achievementName) {
      this.props.submit_unlocked_achievement({
        userId: this.props.userId,
        sessionToken: this.props.sessionToken,
        achievement_type: this.achievementName,
      });
    }
  };

  render() {
    const { currentCardIndex, visibleFlashCardList } = this.state;
    return (
      <>
        <ScreenTitle title={'Flashcards'}/>

        {this.state.showAchievementModal && (
          <MessageModal
            icon='trophy.png'
            title='Achievement Unlocked!'
            message={this.state.message}
            color={'#fff'}
            callback={this.hideAchievementModal}
          />
        )}

        {this.state.showPurchaseGameModal && (
          <MessageModal
            icon='purchase.png'
            title='Purchase the App'
            message='You need to purchase the app from dashboard in order to process further.'
            color={'#fff'}
            callback={() => {
              this.setState({ showPurchaseGameModal: false }, () => {
                this.props.history.replace(ROUTE_CONSTANTS.ROOT);
              });
            }}
            render={() => {
              return (
                <button
                  style={{
                    background: '#fff',
                    border: '1.25px solid #7ebf41',
                    color: '#7ebf41',
                    padding: '.65rem 2rem',
                    borderRadius: '5px',
                    fontWeight: 'bolder',
                    marginTop: '1rem',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    this.setState({ showPurchaseGameModal: false }, () => {
                      this.props.history.replace(ROUTE_CONSTANTS.PURCHASE_P2P);
                    });
                  }}
                >
                  Okay
                </button>
              );
            }}
          />
        )}

        {this.state.loading ? (
          <LoadingModal isVisible={this.state.loading}/>
        ) : (
          <>
            {this.state.visibleFlashCardList.map((item, index) => {
              let { flashCardDesc, flashCardTitle, flashcardId } = item;
              // updateCardId(flashcardId)

              if (index == this.state.visibleCardIndex) {
                return this.renderFlashCard(flashCardDesc, flashCardTitle, flashcardId);
              }
            })}

            <div className='mt-4 row justify-content-between btn-container'>
              <div className='hide_card'>
                <button
                  onClick={() => {
                    this.hideCard(
                      this.state.visibleFlashCardList[
                        this.state.visibleCardIndex
                        ].flashcardId,
                    );
                    // visibleFlashCardList.splice(currentIndex, 1)
                    // updateVisibleCards([...visibleFlashCardList]);
                  }}
                  className='blue-btn'
                >
                  Hide Card{' '}
                </button>
              </div>
              <div
                style={{ display: 'flex' }}
                className={'next-card-container'}
              >
                <button
                  onClick={() => {
                    this.slideCard(-1);
                    //   if (currentIndex > 0)
                    //     updateIndex(currentIndex - 1)
                  }}
                  disabled={currentCardIndex === 0}
                  className={`start-cards-btn first-btn ${
                    currentCardIndex === 0 && 'disabled-btn prev-disabled'
                  }`}
                >
                  Previous Card{' '}
                </button>

                <button
                  onClick={() => {
                    this.slideCard(1);
                    // if (currentIndex < visibleFlashCardList.length - 1)
                    //   updateIndex(currentIndex + 1)
                  }}
                  disabled={
                    currentCardIndex ===
                    this.state.visibleFlashCardList.length - 1
                  }
                  className={`start-cards-btn ${
                    currentCardIndex ===
                    this.state.visibleFlashCardList.length - 1 &&
                    'disabled-btn prev-disabled'
                  }`}
                >
                  Next Card{' '}
                </button>
                {this.state.isFlipped ? (
                  <button
                    onClick={this.handleClick}
                    className='btn btn-md btn-secondary start-cards-btn back_btn'
                    style={{ backgroundColor: '#1b3664', borderColor: '#1b3664' }}
                  >
                    <i>
                      <img
                        src={require('../../../Assets/Images/Icons/back_icon.svg')}
                        alt=''
                      />
                    </i>{' '}
                    Back to Question
                  </button>
                ) : (
                  <button
                    onClick={this.handleClick}
                    className='btn btn-md btn-primary start-cards-btn back_btn'
                  >
                    View Answer
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default withSnackbar(DisplayFlashCardsScreen);
